import { theme } from "@customer-tools-web/component-ui";
import * as React from "react";
import styled, { css } from "styled-components";

import { StatefulButton } from "./StatefulButton";
import { mediaMax } from "./common";

const ReactivateButtonHighlightColor = "#055fb4";

export const ReactivateButton = styled(StatefulButton)<{ LINEHEIGHT: number }>`
  ${({ LINEHEIGHT }) =>
    css`
      height: ${LINEHEIGHT}px;
      line-height: ${LINEHEIGHT}px;
      border-color: ${ReactivateButtonHighlightColor} !important;
      color: ${ReactivateButtonHighlightColor} !important;
      &:hover {
        color: ${theme.textColor} !important;
        border-color: ${theme.textColor} !important;
      }
      &,
      &[disabled] {
        background-color: ${theme.bgLightBlue};
      }
    `};
  ${mediaMax.sm`
      margin-top: 12px;
      display: block;
    `};
`;
